import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-whte-nas',
  templateUrl: './page-whte-nas.component.html',
  styleUrls: ['./page-whte-nas.component.css']
})
export class PageWhteNasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
